import { render, staticRenderFns } from "./LatestWarningModal.vue?vue&type=template&id=6356673e&scoped=true&"
import script from "./LatestWarningModal.vue?vue&type=script&lang=js&"
export * from "./LatestWarningModal.vue?vue&type=script&lang=js&"
import style0 from "./LatestWarningModal.vue?vue&type=style&index=0&id=6356673e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6356673e",
  null
  
)

export default component.exports